import { createStore } from 'vuex'

export default createStore({
  state: {
    authenticated: false,
    user: null,
    datas:{ 
      enterprise: { id: "", name: "", created_at: "", updated_at: "", cores:["#ffff", "#ffff"], constructions: [] }
    },
    dataTitles:[],

  },
  mutations: {
    SET_DATA(state, data) {
      state.datas = data;
    },
    SET_USER(state, data) {
      state.user = data;
    },
    SET_AUTHENTICADED(state, data) {
      state.authenticated = data;
    },
    SET_DATA_TITLES(state) {
      state.dataTitles = [];
      state.datas.enterprise.constructionscolumn.forEach(data => {
        const arrayData = data.date.split('-');
        
        var dataEdit = {
          title:`${arrayData[2]} / ${(new Date(arrayData[0], arrayData[1] - 1, arrayData[2])).toLocaleString('en-GB', { month: 'long' })} / ${arrayData[0]} `,
          date: data.date
        }
        state.dataTitles.push(dataEdit);
      });
    },
  },
  actions: {
    fetchData(context) {
      return fetch(`${process.env.VUE_APP_ENV_API}${process.env.VUE_APP_ENV_EMPREENDIMENTO.replace('{id}', process.env.VUE_APP_ENV_EMPREENDIMENTOID)}`)
        .then((response) => response.json())
        .then((data) => {
          context.commit("SET_DATA", data);
          context.commit("SET_DATA_TITLES");
          
        })
        .catch((err) => console.error(err));
    },
    setAuthenticated(context, data){
      context.commit("SET_AUTHENTICADED", data);
    },
    setUser(context, data){
      context.commit("SET_USER", data);
    }
  },
  getters:{
    datas(state) {
      return state.datas;
    },
    dataTitles(state){
      return state.dataTitles;
    },
    authenticated(state) {
      return state.authenticated;
    },
    user(state) {
      return state.user;
    }
  },
  modules: {
  }
})
